import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function depAirports(state=initialState.depAirports, action) {
    switch (action.type) {
        case commonConstants.DEP_AIRPORTS_SUCCESS:
            return Object.assign({}, state, action.depAirports);
        default:
          return state
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/depAirports.reducer.js